<template>
  <div id="cert_pay_view_outer">
    <div class="pay-title"><span class="iconfont" style="margin-right: 10px;">&#xe609;</span> 微信支付</div>
    <wechat-view v-bind:pay-model="payInforData"
                 v-on:payClicked="payButtonClicked" />
    <div class="pay-amount-title">支付金额：{{amount + '元'}}</div>
    <div v-if="showQrCode" style="margin-top: 15px;color: #666;margin-bottom: 20px;text-align: center;">请扫码付款，
      如无法完成线上支付，可联系工作人员处理，<br>联系人：周宇泽<br>联系电话：18116496980
    </div>
    <div v-else style="margin-top: 15px;color: #666;margin-bottom: 20px;text-align: center;">请点击付款，
      如无法完成线上支付，可联系工作人员处理，<br>联系人：周宇泽<br>联系电话：18116496980
    </div>
  </div>
</template>

<script>

  import WeixinManager from "../../../js/weixin.config";
  import WechatPayCard from "../../common/WechatPayCard";

export default {
  name: "CertApplicationCostPayVue",
  props: {
    judge: {
      default: () => null
    }
  },
  components: {
    WechatView: WechatPayCard
  },
  data() {
    return {
      amount: 100,
      payInforData: null,
      tradeType: null,
      checkInterval: null,
      showQrCode: true,
      neededAutoCheckPayStatus: false,
      code: null,
      wechatData: null,
      tempStatus: null,
      valueInSeconds: 10,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    user() {
      return this.$store.state.user;
    },
    dataManager() {
      return this.$store.state.dataStore;
    },
  },
  destroyed() {
    this.closeInterval();
  },
  mounted() {
    this.initPayParams();
    this.initAutoCode();
    this.loadQrCodeData();
  },
  methods: {
    initPayParams() {
      if (this.isPc()) { // pc端
        this.tradeType = 'NATIVE';
        this.showQrCode = true;
        this.neededAutoCheckPayStatus = true;
      } else { // 移动端
        this.showQrCode = false;
        if (this.isWeixin()) {
          this.tradeType = 'JSAPI';
          this.neededAutoCheckPayStatus = false;
        } else {
          this.tradeType = 'MWEB';
          this.neededAutoCheckPayStatus = true;
        }
      }
    },

    initAutoCode() {
      if (this.tradeType == 'JSAPI') {
        let query = this.$route.query;
        let state = query.state;
        if (state == this.weichatAutoState.pay) {
          let code = query.code;
          if (code != undefined) {
            this.code = code;
            this.$router.push({
              name: this.$route.name,
              params: this.$route.params,
              query: {}
            });
          }
        } else {
          let redirect_url = window.location.href;
          WeixinManager.jsapi_payAutorize(redirect_url);
        }
      } else if (this.tradeType == 'MWEB') {
        //outTradeNo
        let query = this.$route.query;
        let outTradeNo = query.outTradeNo;
        if (outTradeNo != undefined && outTradeNo != null && outTradeNo.length > 0) {
          //...更新状态
          this.checkPayStatusAtBegin(outTradeNo);
        }
      }
    },

    weichatPaySuccess() {
      this.$toast('支付成功！');
      let status = this.tempStatus;
      if (status == null) {
        return;
      }
      this.tempStatus = null;
      this.$emit('paySuccess', {
        status
      });
    },

    payButtonClicked() {
      let params = this.payInforData;
      if (params == null) {
        return;
      }
      if (this.tradeType == 'JSAPI') {
        let _this = this;
        WeixinManager.jsapi_sendPayRequest(params, function (data) {
          _this.$toast('支付成功！');
          _this.checkPayStatus();
        }, function (data) {
          // loadFlags.close();
          // _this.$toast(data.err_msg);

        });
      } else { // h5 支付
        let mwebUrl = params.mwebUrl;
        if (mwebUrl != null && mwebUrl.length > 0) {
          this.valueInSeconds = 2;
          let url =  window.location.href;
          if (this.isSafari()) {
            url += "?outTradeNo=" + params.outTradeNo;
            url = encodeURI(url);
          }
          mwebUrl += '&redirect_url=';
          mwebUrl += url;
          this.closeInterval();
          this.startInterval();
          window.open(mwebUrl, '_self');
        }
      }
    },

    loadQrCodeData() {
      let judgeData = this.judge;
      if (judgeData == null) {
        return;
      }

      let params = {
        productId: -2,
        tradeType: this.tradeType,
        tableId: judgeData.id,
      };

      if (this.code != null) {
        params.code = this.code;
      }
      let _this = this;
      this.httpManager.ajax.getPayUnifiedorderData(params, function (data) {
        console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.payInforData = data.data;
          _this.code = null;
          if (_this.neededAutoCheckPayStatus) {
            _this.startInterval();
          }
          return;
        }
      }, function (data) {
      });
    },

    updateJudgeStatus(status) {
      let id = this.judge.id;
      let params = {
        status: status,
        auditStatus: 1,
        id,
      };
      let _this = this;
      this.httpManager.ajax.updateJudgeStatusData(params, function (data) {
        if (data.code == 0) {
          _this.tempStatus = status;
          _this.weichatPaySuccess();
          return;
        }
        _this.$toast("数据更新失败！");
      }, function (data) {
        _this.$toast("数据更新失败！");
      });
    },

    checkPayStatusAtBegin(outTradeNo) {
      let params = {
        outTradeNo
      };
      let _this = this;
      this.httpManager.ajax.getPayWxPayCheckData(params, function (data) {
        let code = data.data;
        if (code == 1) {
          _this.checkInterval = null;
          let modified = _this.judge.modified;
          _this.$router.push({
            name: _this.$route.name,
            params: _this.$route.params,
            query: {}
          });
          if (modified == 1) {
            _this.updateJudgeStatus(4);
          } else {
            _this.updateJudgeStatus(5);
          }
          //...
        } else {
          _this.startInterval();
        }
      }, function (data) {
        _this.startInterval();
      });
    },


    checkPayStatus() {
      let outTradeNo = this.payInforData.outTradeNo;
      let params = {
        outTradeNo
      };
      let _this = this;
      this.httpManager.ajax.getPayWxPayCheckData(params, function (data) {
        let code = data.data;
        if (code == 1) {
          _this.checkInterval = null;
          let modified = _this.judge.modified;
          if (modified == 1) {
            _this.updateJudgeStatus(4);
          } else {
            _this.updateJudgeStatus(5);
          }
          //...
        } else {
          _this.startInterval();
        }
      }, function (data) {
        _this.startInterval();
      });
    },

    startInterval() {
      if (!this.neededAutoCheckPayStatus || this.payInforData == null) {
        return;
      }
      this.checkInterval = setTimeout(this.checkPayStatus, this.valueInSeconds * 1000);
    },
    closeInterval() {
      if (this.checkInterval != null) {
        clearTimeout(this.checkInterval);
        this.checkInterval = null;
      }
    },
  }
}
</script>

<style scoped>
  #cert_pay_view_outer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #cert_pay_view_outer .pay-title {
    font-size: 1.2rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 30px;
  }

  #cert_pay_view_outer .pay-amount-title {
    margin-top: 30px;
    color: #fc1a34;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/certificates/application/CertApplicationCostPayVue.vue